import { render } from "./AdminProfile.vue?vue&type=template&id=1d39448c"
import script from "./AdminProfile.vue?vue&type=script&lang=js"
export * from "./AdminProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__